export default function BlurStack() {
  this.r = 0
  this.g = 0
  this.b = 0
  this.a = 0
  this.next = null
}